export default __webpack_public_path__ + "static/media/Styleguide1.22b931ed.png";